// import { usePanelUser } from "@/hooks/auth";
import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";

export type Props = {
  value: any | undefined;
  setValue?: Dispatch<SetStateAction<any>> | undefined;
};

export type TypeDataPainel = {
  [key: string]: any;
};

export type TypeContext = {
  data: TypeDataPainel;
  setData: Dispatch<SetStateAction<any>>;
  isNavbarHidden: boolean;
  setIsNavbarHidden: Dispatch<SetStateAction<boolean>>;
};

export const DataContext = createContext<TypeContext | undefined>(undefined);
export const useContextData = () => {
  const context = useContext(DataContext) as TypeContext;
  if (!context) {
    throw new Error(
      "useContextData deve ser usado dentro de um ContextProviderPainel"
    );
  }

  return context;
};

export const ContextProviderPainel = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [data, setData] = useState<TypeDataPainel>({
    tenants: { value: undefined, setValue: undefined },
    plans: { value: undefined, setValue: undefined },
    courses: { value: undefined, setValue: undefined },
  });
  const [isNavbarHidden, setIsNavbarHidden] = useState(false);

  return (
    <DataContext.Provider value={{ data, setData, isNavbarHidden, setIsNavbarHidden }}>
      {children}
    </DataContext.Provider>
  );
};
